import SubmitReferral from "../components/partner-dashboard/submit-referral";
import CommissionEarned from "../components/partner-dashboard/commission-earned";
import EnrolledClients from "../components/partner-dashboard/enrolled-clients";
import PendingEnrollments from "../components/partner-dashboard/pending-enrollments";
import WelcomeBack from "../components/partner-dashboard/welcome-back";
import MainLayout from "../layouts/main-layout";
import { FeatureFlags } from "../types/featureFlags";
import { useFlags } from "launchdarkly-react-client-sdk";
import AlertBlockHighTaxRisk from "../components/partner-dashboard/alerts/high-tax-risk";
import AlertBlockNewTaxPrep from "../components/partner-dashboard/alerts/new-tax-prep";
import AlertBlockTaxFraud from "../components/partner-dashboard/alerts/tax-fraud";
import "../components/partner-dashboard/partner-dashboard.css";

function PartnerDashboard() {
  const flagList: FeatureFlags = useFlags();

  return (
    <MainLayout>
      <div className="page-container">

      <WelcomeBack />
      <div className="partnerDashboard">
        <div className="row">
          <div className="col-md-4">
            <PendingEnrollments />
            <br />
          </div>
          <div className="col-md-4">
            <EnrolledClients />
            <br />
          </div>
          <div className="col-md-4">
            <CommissionEarned />
            <br />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <SubmitReferral />
            <br />
          </div>
          {flagList?.featurePartnerAlerts &&
            <div className="col-md-6">
              <AlertBlockHighTaxRisk />
              <br />
              <AlertBlockNewTaxPrep />
              <br />
              <AlertBlockTaxFraud />
              <br />
            </div>
          }
        </div>
      </div>
      </div>
      
    </MainLayout>
  )
};

export default PartnerDashboard;